import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import i18n from 'modules/core/lib/i18n'

import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import { useBulkDestroyUploadProcessDocuments } from 'modules/documents/hooks/useBulkDestroyUploadProcessDocuments'

interface Props {
  documents?: Document[]
  onClose: () => void
}

const DeleteAllDocumentsModal = ({ documents = [], onClose }: Props) => {
  const documentIds = documents.map((document) => document.id)

  const { loading, bulkDestroyUploadProcessDocuments } = useBulkDestroyUploadProcessDocuments()

  const bulkDestroy = async (closePortal: ClosePortalFn) => {
    await bulkDestroyUploadProcessDocuments({ documentIds: documentIds })
    closePortal()
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('documents.delete_all.confirm.title')}
      description={i18n.t('documents.delete_all.confirm.description')}
      onClose={onClose}
      onSubmit={(closePortal: ClosePortalFn) => bulkDestroy(closePortal)}
      footer={
        <Button type="negative" disabled={loading} submit>
          {i18n.t('documents.delete_all.button_label')}
        </Button>
      }
    />
  )
}

export default DeleteAllDocumentsModal
